/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { GlobalContext } from '../contexts';

import type { CoreModuleAddons } from '../../../../core-modules/base-core-module';

export const useGlobalAddons = (): CoreModuleAddons => useContext(GlobalContext).addons ?? {};
